<template>
    <div id="filters" class="filters">
        <b-form class="filters" @submit="submit">
            <div>
                <b-row>
                    <b-col md="12">
                        <b-button v-b-toggle.collapse-property variant="outline-secondary">Property Types</b-button>
                        <b-collapse id="collapse-property" class="mt-2">
                            <b-form-checkbox-group
                                id="property_types"
                                v-model="criteria_breadcrumbs"
                                name="property_types"
                                :options="property_types"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                        </b-collapse>
                    </b-col>

                    <b-col md="12" class="mt-3 limit">
                        <b-button v-b-toggle.collapse-neighborhoods variant="outline-secondary">Neighborhoods</b-button>
                        <b-collapse id="collapse-neighborhoods" class="mt-2 neighborhood">
                            <b-form-checkbox-group
                                id="neighborhoods"
                                v-model="criteria_breadcrumbs"
                                name="neighborhoods"
                                :options="this.neighborhoods"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                        </b-collapse>
                    </b-col>

                    <b-col md="12" class="mt-3">
                        <b-button v-b-toggle.collapse-price variant="outline-secondary">Price Range</b-button>
                        <b-collapse id="collapse-price" class="mt-2">
                            <b-form-checkbox-group
                                id="price_ranges"
                                v-model="criteria_breadcrumbs"
                                name="price_ranges"
                                :options="this.price_ranges"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                        </b-collapse>
                    </b-col>

                    <b-col md="12" class="mt-3">
                        <b-button v-b-toggle.collapse-home-type variant="outline-secondary">Home Type</b-button>
                        <b-collapse id="collapse-home-type" class="mt-2">
                            <b-form-checkbox-group
                                id="home-types"
                                v-model="criteria_breadcrumbs"
                                name="home-type"
                                :options="this.styles"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                        </b-collapse>
                    </b-col>

                    <b-col md="12" class="mt-3">
                        <b-button v-b-toggle.collapse-bedrooms variant="outline-secondary">Bedrooms</b-button>
                        <b-collapse id="collapse-bedrooms" class="mt-2">
                            <b-form-checkbox-group
                                id="bedrooms"
                                v-model="criteria_breadcrumbs"
                                name="bedrooms"
                                :options="this.bedrooms"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                        </b-collapse>
                    </b-col>

                    <b-col md="12" class="mt-3">
                        <b-button v-b-toggle.collapse-bathrooms variant="outline-secondary">Bathrooms</b-button>
                        <b-collapse id="collapse-bathrooms" class="mt-2">
                            <b-form-checkbox-group
                                id="bathrooms"
                                v-model="criteria_breadcrumbs"
                                name="bathrooms"
                                :options="this.bathrooms"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                        </b-collapse>
                    </b-col>

                    <b-col md="12" class="mt-3">
                        <b-button v-b-toggle.collapse-status variant="outline-secondary">Listing Status</b-button>
                        <b-collapse id="collapse-status" class="mt-2">
                            <b-form-checkbox-group
                                id="status"
                                v-model="criteria_breadcrumbs"
                                name="status"
                                :options="this.status"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                        </b-collapse>
                    </b-col>
                </b-row>
            </div>
            <b-button @click="submit" class="mt-2">Submit</b-button>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'filters',

    created() {
        this.criteria_breadcrumbs = this.criteria;
        this.getNeighborhoods();
        this.getStyles();
    },
    data() {
        return {
            criteria_breadcrumbs: [],
            styles: [],
            neighborhoods: [],
            property_types: [
                {text: "Single Family", value: {text: "Single Family", value: "pt-SF", label: "Single Family"}, label: "Single Family"},
                {text: "Condominum", value: {text: "Condominum", value: "pt-CO", label: "Condominums"}, label: "Condominums"},
                {text: "MultiFamily", value: {text: "MultiFamily", value: "pt-MF", label: "Multi-Family Homes"}, label: "Multi-Family Homes"},
                {text: "Land", value: {text: "Land", value: "pt-RL", label: "Residential Land"}, label: "Residential Land"}
            ],
            price_ranges: [
                {text: "100,000 and less", value: {text: "100,000 and less", value: "pr-0", "label": "100,000 and less"}, "label": "100,000 and less"},
                {text: "1 - 200,000", value: {text: "1 - 200,000", value: "pr-1", "label": "1 - 200,000"}, "label": "1 - 200,000"},
                {text: "2 - 300,000", value: {text: "2 - 300,000", value: "pr-2", "label": "2 - 300,000"}, "label": "2 - 300,000"},
                {text: "3 - 400,000", value: {text: "3 - 400,000", value: "pr-3", "label": "3 - 400,000"}, "label": "3 - 400,000"},
                {text: "4 - 500,000", value: {text: "4 - 500,000", value: "pr-4", "label": "4 - 500,000"}, "label": "4 - 500,000"},
                {text: "500,000+", value: {text: "500,000+", value: "pr-5", "label": "500,000 and more"}, "label": "500,000 and more"}
            ],
            bedrooms: [
                {text: "1 Bed", value: {text: "1 Bed", value: "bd-1", "label": "1 Bed"}, "label": "1 Bed"},
                {text: "2 Beds", value: {text: "2 Beds", value: "bd-2", "label": "2 Bed"}, "label": "2 Bed"},
                {text: "3 Beds", value: {text: "3 Beds", value: "bd-3", "label": "3 Bed"}, "label": "3 Bed"},
                {text: "4 Beds", value: {text: "4 Beds", value: "bd-4", "label": "4 Bed"}, "label": "4 Bed"},
                {text: "5 Beds", value: {text: "5 Beds", value: "bd-5", "label": "5 Bed"}, "label": "5 Bed"},
            ],
            bathrooms: [
                {text: "1 Bath", value: {text: "1 Bath", value: "br-1", "label": "1 Bath"}, "label": "1 Bath"},
                {text: "2 Bath", value: {text: "2 Bath", value: "br-2", "label": "2 Bath"}, "label": "2 Bath"},
                {text: "3 Bath", value: {text: "3 Bath", value: "br-3", "label": "3 Bath"}, "label": "3 Bath"},
                {text: "4 Bath", value: {text: "4 Bath", value: "br-4", "label": "4 Bath"}, "label": "4 Bath"},
                {text: "5 Bath", value: {text: "5 Bath", value: "br-5", "label": "5 Bath"}, "label": "5 Bath"},
            ],
            status: [
                {text: "Active", value: {text: "Active", value: "ls-1", "label": "Active Status"}, "label": "Active Status"},
                {text: "Active and Pending", value: {text: "Active and Pending", value: "ls-2", "label": "Active and Pending Status"}, "label": "Active and Pending Status"},
                {text: "Pending", value: {text: "Pending", value: "ls-3", "label": "Pending Status"}, "label": "Pending Status"},
                {text: "Closed", value: {text: "Closed", value: "ls-4", "label": "Closed Status"}, "label": "Closed Status"},
                {text: "Any Status", value: {text: "Any Status", value: "ls-5", "label": "All Listing Statuses"}, "label": "All Listing Statuses"},
            ]
        }
    },
    methods: {
        addCriteria(criterion) {
            let _self = this;
            _self.$eventHub.$emit('criteria::added', criterion);
        },
        clear() {
            this.criteria = this.criteria_breadcrumbs = [];
            this.getListings();
        },
        removeCriteria(criterion) {
            let _self = this;
            _self.$eventHub.$emit('criteria::removed', criterion);
        },
        submit()
        {
            let _self = this;
            _self.$eventHub.$emit('criteria::submit',this.criteria_breadcrumbs);
        },
        getNeighborhoods() {
            let _self = this;
            let promise = axios.get('/api/neighborhoods?type=mobile');

            return promise.then((response) => {

                _self.neighborhoods = $.map(response.data, function (dataItem) {
                    return dataItem;
                });
            });
        },
        getStyles() {
            let _self = this;
            let promise = axios.get('/api/styles?type=mobile');

            return promise.then((response) => {

                _self.styles = $.map(response.data, function (dataItem) {
                    return dataItem;
                });
            });
        },
    }
}

</script>

<style>

.container .dropdown .dropdown-menu a:hover {
    color: #fff;
    background-color: darkgrey;
    border-color: #fff;
}

</style>
